import * as actionTypes from 'src/old/actions';

const initialState = { emailQueue: [] };

const emailQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EMAILQUEUE: {
      return {
        ...state,
        emailQueue: action.response
      };
    }

    case actionTypes.POST_EMAILQUEUE: {
      return {
        ...state,
        emailQueue: [...state.emailQueue.filter(email => email.ReceiptHandle !== action.response.ReceiptHandle)]
      };
    }

    case actionTypes.DELETE_EMAILQUEUE: {
      return {
        ...state,
        emailQueue: [...state.emailQueue.filter(email => email.ReceiptHandle !== action.response)]
      };
    }

    default: {
      return state;
    }
  }
};

export default emailQueueReducer;
